// Feature flags for the Survey Explorer.
//
// TEXT_CLASSIFICATION gates the classified free-text Analysis surface
// (Semantic Volume Pareto + Ambiguous review). Defaults ON; set
// REACT_APP_TEXT_CLASSIFICATION=off at build time to fall back to the
// legacy free-text stub.
export const TEXT_CLASSIFICATION =
    (process.env.REACT_APP_TEXT_CLASSIFICATION ?? 'on') !== 'off';
